export const AUTH_CONFIG = {
  clientId: import.meta.env.VITE_API_CLIENT_ID,
  domain: import.meta.env.VITE_AUTH_DOMAIN,
  audience: 'travel.analytics',
  useRefreshTokens: true,
  cacheLocation: 'localstorage' as const,
}
